export default __webpack_public_path__ + "3ec876a95e2e9de467231aa294a05ecf.png";